import { useLayoutEffect } from 'react';
import {
  Route,
  Switch,
  Redirect,
  useLocation,
  useHistory,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';

import LoginView from './views/LoginView/LoginView';
import SelectCustomerView from './views/SelectCustomerView/SelectCustomerView';
import SearchCustomerView from './views/SearchCustomerView/SearchCustomerView';
import ErrorFallbackView from './views/ErrorFallbackView/ErrorFallbackView';
import NewReportView from './views/NewReportView/NewReportView';

const PrivateRoute = ({ children, ...rest }) => {
  const { isLoggedIn } = useSelector((state) => state.user);
  const history = useHistory();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          <ErrorBoundary
            FallbackComponent={ErrorFallbackView}
            onReset={() => history.push('/')}
          >
            {children}
          </ErrorBoundary>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  children: PropTypes.node,
};

const Routes = () => {
  const location = useLocation();

  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Switch>
      <Route path="/login" component={LoginView} />

      <PrivateRoute exact path="/customers">
        <SelectCustomerView />
      </PrivateRoute>
      <PrivateRoute exact path="/customers/search">
        <SearchCustomerView />
      </PrivateRoute>
      <PrivateRoute exact path={['/customers/:clientId/visit/:reportId']}>
        <NewReportView />
      </PrivateRoute>
      <PrivateRoute path="/">
        <Redirect to="/customers" />
      </PrivateRoute>
    </Switch>
  );
};

export default Routes;
